export default __webpack_public_path__ + "efbbf4b91c0a290f797621317e451d42.png";